const ensureMeta = (selector, attribute, value) => {
  if (typeof document === 'undefined') return null;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    if (attribute === 'name') {
      element.setAttribute('name', value.key);
    } else if (attribute === 'property') {
      element.setAttribute('property', value.key);
    }
    document.head.appendChild(element);
  }
  element.setAttribute('content', value.content);
  return element;
};

const ensureLink = (rel, href) => {
  if (typeof document === 'undefined') return;
  let link = document.head.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const truncate = (value, length = 160) => {
  if (!value) return '';
  if (value.length <= length) return value;
  return value.slice(0, length - 1).trimEnd() + '…';
};

export function setSeoTags({ title, description, url, type = 'website' }) {
  if (typeof document === 'undefined') return;
  if (title) {
    document.title = title;
    ensureMeta('meta[property="og:title"]', 'property', { key: 'og:title', content: title });
    ensureMeta('meta[name="twitter:title"]', 'name', { key: 'twitter:title', content: title });
  }
  const desc = truncate(description);
  if (desc) {
    ensureMeta('meta[name="description"]', 'name', { key: 'description', content: desc });
    ensureMeta('meta[property="og:description"]', 'property', { key: 'og:description', content: desc });
    ensureMeta('meta[name="twitter:description"]', 'name', { key: 'twitter:description', content: desc });
  }
  ensureMeta('meta[name="robots"]', 'name', { key: 'robots', content: 'index, follow' });
  ensureMeta('meta[property="og:type"]', 'property', { key: 'og:type', content: type });
  ensureMeta('meta[name="twitter:card"]', 'name', { key: 'twitter:card', content: 'summary_large_image' });
  if (url) {
    ensureMeta('meta[property="og:url"]', 'property', { key: 'og:url', content: url });
    ensureLink('canonical', url);
  }
}

export function getCanonicalUrl(path = '') {
  if (typeof window === 'undefined') return path;
  const origin = window.location.origin || '';
  return origin + path;
}
